// extracted by mini-css-extract-plugin
module.exports = {"hero-image":"_2hV8P"};